export { DMS_MODULE } from '../constants';
export const NAME = 'UzavUcetni';
export const CRUMB_LABEL_KEY = 'setUzaverkaUcto';

export enum TYP_UCETNI_UZAVERKA {
	PRUBEZNA = 1,
	MESICNI = 2,
}
